
import { Component, Vue, Prop, Watch } from "vue-property-decorator";

@Component({
  name: "Paginator"
})
export default class Paginator extends Vue {
  @Prop(Number) readonly limit!: number;
  @Prop(Number) readonly totalRows!: number;
  @Prop(Function) readonly onPageChange!: Function;

  currentPage: number = 1;
  pages: number[] = [];

  mounted() {
    this.pagesCalculator();
  }
  @Watch("limit")
  onLimitChange(val) {
    this.pagesCalculator();
  }
  @Watch("totalRows")
  onRowsChange(val) {
    this.pagesCalculator();
  }
  pagesCalculator() {
    let pages: number[] = [];
    for (
      let i: number = 1;
      i < Math.ceil(this.totalRows / this.limit) + 1;
      i++
    ) {
      pages.push(i);
    }
    this.pages = pages;
  }
  changePage(page: number) {
    if (page < 1 || page > this.pages.length) return;
    this.currentPage = page;
    this.onPageChange(this.currentPage, this.limit);
  }

  activeClass(page: number) {
    return page === this.currentPage ? "active" : "";
  }
}
